import React, { useEffect, useState } from "react";
import { Col, Row, Card, Button, Table } from "@themesberg/react-bootstrap";
import "../../scss/fcsvendor/layout/_vendor.scss";
import { getProjectAnnoucement } from "../../app/api";
import { useParams } from "react-router-dom";
import axios from "axios";
import Loader from "../../components/Loader";
import { useHistory } from "react-router-dom";
import { Routes } from "../../routes";
import moment from "moment"
export default () => {
  const { id } = useParams();
  const history = useHistory();

  const [deadline, setDeadline] = useState("");

  const [status, setStatus] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState("");
  const [vendor, setVendorName] = useState([]);
  const fetchSingleProject = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(getProjectAnnoucement(id), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
      });
      // console.log(response.data);
      setVendorName(response.data?.email_logs);
      setDeadline(response.data?.announcement?.deadline);
      setStatus(response.data?.announcement?.active);
      setTitle(response.data?.announcement?.title);
      setDescription(response.data?.announcement?.description);
      setDate(response.data?.announcement?.created_at);
    } catch (error) {
      // console.error("Error fetching Project:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSingleProject();
  }, [id]);
  const handleBackClick = () => {
    history.push(Routes.ProjectAnnoucement.path);
  };
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-2">
            <div className="d-block  mb-md-0">
              <h4 className="mb-0">Project Announcement Detail</h4>
            </div>
            <Button
              variant="primary"
              onClick={handleBackClick}
              className=" me-2"
            >
              <span>Back</span>
            </Button>
          </div>

         
          <Row className="justify-content-md-center">
            <Col xs={12} sm={12} xl={12} lg={12} className="mb-4">
              <Card border="light" className="shadow-sm">
                <Card.Body>
                 
                  <Col xs={12} sm={12} xl={12} lg={12}>
                   <Row>
                                                          <Col xs={12} sm={6} xl={4} lg={4}>
                                                            <p className="vendor-title">Title:</p>{" "}
                                                            <p className="vendor-detail">{title}</p>{" "}
                                                          </Col>
                                    
                                                          <Col xs={12} sm={6} xl={4} lg={4}>
                                                            <p className="vendor-title">Status:</p>
                                                            <p className="vendor-detail"> {status === "0" ? "InActive" : "Active"}</p>{" "}
                                                          </Col>
                                    
                                                          <Col xs={12} sm={6} xl={4} lg={4}>
                                                            <p className="vendor-title">Description:</p>
                                                            <p className="vendor-detail">{description}</p>{" "}
                                                          </Col>
                                                        </Row>
                    
                                                        <Row>
                                                          <Col xs={12} sm={6} xl={4} lg={4}>
                                                            <p className="vendor-title">Deadline:</p>{" "}
                                                            <p className="vendor-detail">{moment(deadline).format("MM/DD/YYYY")}</p>{" "}
                                                          </Col>
                                    
                                                          <Col xs={12} sm={6} xl={4} lg={4}>
                                                            <p className="vendor-title">Created At:</p>
                                                            <p className="vendor-detail">{moment(date).format("MM/DD/YYYY")}</p>{" "}
                                                          </Col>
                                    
                                                       
                                                        </Row>

                   
                  </Col>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="justify-content-md-center">
            <Col xs={12} sm={12} xl={12} lg={12} className="mb-4">
              <Card
                border="light"
                className="table-wrapper table-responsive shadow-sm"
              >
                <Card.Body className="p-0">
                  <Table hover className="user-table align-items-center">
                    {loading ? (
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <Loader />
                      </div>
                    ) : (
                      <>
                        <thead>
                          <tr>
                            {/* <th className="border-bottom">ID</th> */}
                            <th className="border-bottom">Vendor Name</th>

                            <th className="border-bottom">Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {vendor.map((projects, index) => (
                            <tr key={index}>
                              <td>
                                <span className="fw-normal">
                                  {" "}
                                  {projects?.vendor_name}{" "}
                                </span>
                              </td>
                              <td>
                                <span className="fw-normal">
                                  {projects?.status}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </>
                    )}
                  </Table>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};
